const t = {
  name: "Lock",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 17V13H11V17H13Z" fill="currentColor"/>
<path d="M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V8C18.6569 8 20 9.34315 20 11V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V11C4 9.34315 5.34315 8 7 8V6ZM15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V8H15V6ZM6 11V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V11C18 10.4477 17.5523 10 17 10H7C6.44772 10 6 10.4477 6 11Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Lock
};
